<script setup>
import { computed, defineProps, toRefs } from "vue";

const props = defineProps({
  quoteObj: {
    type: Object,
    required: true,
    default: () => {},
  },
});
const { quoteObj } = toRefs(props);

const learnerQuote = computed(() => {
  return quoteObj?.value?.learner_quote;
});

const learnerName = computed(() => {
  return quoteObj?.value?.learner_name;
});

const learnerDetail = computed(() => {
  return quoteObj?.value?.learner_details;
});
</script>
<template>
  <div>
    <blockquote class="text-xl mt-4 lg:mt-8 mb-2 font-bold text-indigo-base">
      {{ learnerQuote || "" }}
    </blockquote>
    <p
      class="text-sm "
      :class="[
        secondaryColor ? `${secondaryColorClass}` : `text-university-secondary`
      ]"
      >
      <cite>{{ learnerName || "" }}</cite>
    </p>
    <p 
      class="text-xs font-semibold"
      :class="[
        secondaryColor ? `${secondaryColorClass}` : `text-university-secondary`
      ]"
    >
      {{ learnerDetail || "" }}
    </p>
  </div>
</template>
